import { CONVERSATION_TYPE } from '../../settings/constants';
import { KEYS } from '../../messages/constants';

const keyHandlers = {
  [KEYS.ARROW_UP]: (index, convs) => (convs.length + (index === -1 ? 0 : index) - 1) % convs.length,
  [KEYS.ARROW_DOWN]: (index, convs) =>
    (convs.length + (index === -1 ? 0 : index) + 1) % convs.length,
  // TODO disabled for now as alt + side arrows has different responsibility in browsers
  // [KEYS.ARROW_LEFT]: (index, convs) => {
  //   const offsetIndex = [...convs.slice(index), ...convs.slice(0, index)].reverse().findIndex(conv => conv.unreadItems);
  //   if (offsetIndex === -1) {
  //     return;
  //   }
  //   return (2 * convs.length - offsetIndex - 1 - convs.slice(index).length) % convs.length;
  // },
  // [KEYS.ARROW_RIGHT]: (index, convs) => {
  //   const offsetIndex = [...convs.slice(index), ...convs.slice(0, index)].findIndex(conv => conv.unreadItems);
  //   if (offsetIndex === -1) {
  //     return;
  //   }
  //   return (offsetIndex + convs.slice(0, index).length) % convs.length;
  // },
};

export default class ConversationService {
  constructor($state, $rootScope, Authentication, Utils) {
    'ngInject';

    Object.assign(this, { $state, $rootScope, Authentication, Utils });
  }

  canStartConversation(predicate = () => true) {
    const {
      orgSettings: { usersCanStartConversation },
      org: { isPremium },
      isManager,
    } = this.Authentication.user;

    if (!isPremium || isManager) {
      return true;
    } else if (usersCanStartConversation === CONVERSATION_TYPE.NONE) {
      return false;
    } else if (predicate(usersCanStartConversation)) {
      return true;
    }
    return false;
  }

  userCanStartPrivateConversation() {
    return this.canStartConversation((type) =>
      [CONVERSATION_TYPE.ALL, CONVERSATION_TYPE.PRIVATE_ONLY].includes(type)
    );
  }

  userCanStartGroupConversation() {
    return this.canStartConversation((type) => type === CONVERSATION_TYPE.ALL);
  }

  userCanStartConversation() {
    return this.userCanStartPrivateConversation() || this.userCanStartGroupConversation();
  }

  setupKeyBindings(conversations) {
    const handler = (e) => {
      if (!e.altKey) {
        return;
      }

      const key = e.which || e.keyCode;

      if (!(key in keyHandlers)) {
        return;
      }

      const convs = conversations
        .filter((c) => !c.archived)
        .map(({ id, cleanUrlName, lastwriteId, private: priv, silenced, unreadItems, pinned }) => ({
          id,
          cleanUrlName,
          lastwriteId,
          isPrivate: Number(priv),
          silenced,
          unreadItems,
          pinned,
        }));
      convs.sort(
        (a, b) =>
          a.pinned - b.pinned ||
          a.isPrivate - b.isPrivate ||
          a.silenced - b.silenced ||
          b.lastwriteId - a.lastwriteId
      );

      const index = convs.findIndex(
        (c) => c.id === parseInt(this.$state.params.conversationId, 10)
      );
      const nextIndex = keyHandlers[key](index, convs);

      if (!convs[nextIndex]) {
        return;
      }

      this.$rootScope.$evalAsync(() => {
        const { id, cleanUrlName } = convs[nextIndex];

        this.$state.go('messages.detail', {
          conversationId: id,
          conversationName: cleanUrlName,
        });
      });

      e.stopPropagation();
    };

    document.addEventListener('keydown', handler, true);

    return () => document.removeEventListener('keydown', handler, true);
  }

  openConversation = (userId) => {
    const queryUserId = Array.isArray(userId) ? userId.join(',') : userId;

    this.$state.go('messages', {
      path: `start?userId=${queryUserId}`,
    });
  };

  createNewConversation = () => {
    this.$state.go('messages', {
      path: 'compose',
    });
  };
}
